import React from 'react';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
  EButtonStyle,
} from '@/components/common/Button/Button';
import styles from './BaseBanner.module.scss';
import { PublicImage } from '@/components/common/PublicImage/PublicImage';
import { ReactComponent as CloseIcon } from '@/assets/icons/actions/close.svg';
import { TranslationKey } from '@/types/i18n.types';
import { IMAGES } from '@/constants/ui/images';

interface IBaseBannerBaseProps {
  text: string | React.ReactElement;
  button?: {
    text: TranslationKey;
    onClick: () => void;
  };
  icon?: string;
  children?: React.ReactNode;
}

type IBaseBannerProps = IBaseBannerBaseProps &
  (
    | { onClose: () => void; closeAriaLabel: string }
    | { onClose?: undefined; closeAriaLabel?: undefined }
  );

export const BaseBanner: React.FC<IBaseBannerProps> = ({
  text,
  button,
  icon,
  children,
  onClose,
  closeAriaLabel,
}) => {
  return (
    <div className={styles.wrapper}>
      {icon && (
        <PublicImage
          src={`${IMAGES.PATHS.MISC}/${icon}`}
          alt={`${icon}`}
          className={styles.icon}
        />
      )}
      <div className={styles.text}>{text}</div>
      <div className={styles.content}>
        {children}
        {button && (
          <Button
            onClick={button.onClick}
            text={button.text}
            fillWidth
            dataAttribute="base-banner-button"
            hierarchy={EButtonHierarchy.upsell}
            size={EButtonSize.sm}
            className={styles.button}
          />
        )}
        {onClose && (
          <Button
            onClick={onClose}
            iconLead={CloseIcon}
            hierarchy={EButtonHierarchy.primary}
            buttonStyle={EButtonStyle.ghost}
            size={EButtonSize.sm}
            ariaLabel={closeAriaLabel}
            dataAttribute="base-banner-close"
          />
        )}
      </div>
    </div>
  );
};
